import { fromStoreGroupQueryDataToStores } from "./adapters.js";
import { GET_STORE_GROUP } from "./queries.js";
async function getPageData(apolloClient, groupName, locale) {
  try {
    const { data, error } = await apolloClient.query({
      query: GET_STORE_GROUP,
      variables: {
        groupName
      },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    const storeGroupQueryData = data.stores;
    const stores = fromStoreGroupQueryDataToStores(storeGroupQueryData);
    if (error) {
      console.error(error);
    }
    if (!stores) {
      return null;
    }
    return { stores };
  } catch (e) {
    console.error(e);
    return null;
  }
}
export {
  getPageData
};
//# sourceMappingURL=data.js.map
